export default __webpack_public_path__ + "static/media/act_foundation.a23ab91a.png";